import React from 'react'
import { connect } from 'react-redux'
import { Page } from '../../../components/page/Page'
import { DefaultFormToolBar } from '../../../components/toolbar/DefaultFormToolBar'
import { acoes, icons, routes } from '../../../constants'
import { actions } from '../orcamento.actions'
import { OrcamentoForm } from './OrcamentoForm'
import _ from 'lodash'
import storage from '../../../services/stoage.service'
import utils from '../../../utils'
import { logarAcesso } from '../../../services/api-log-acesso'
import { actions as pessoaActions } from '../../pessoa/pessoa.actions'
import { ConfirmDialog } from '../../../components/confirmDialog/ConfirmDialog'

const mapStateToProps = (state) => {
  const record = state.crudOrcamentoState.currentRecord
  const currentCompany = storage.getCompany()
  const currentUnit = storage.getUnit()
  const isUsarWebWhatsapp = utils.isUsarWebWhatsapp(currentCompany, currentUnit)
  return {
    messages: state.crudOrcamentoState.messages,
    record,
    statePessoaFisica: state.crudPessoaFisicaState,
    currentUser: state.appState.currentUser,
    canEditHistorico: storage.getAcao(acoes.ACAO_ALTERAR_HISTORICO),
    canRemoveHistorico: storage.getAcao(acoes.ACAO_REMOVER_HISTORICO),
    isSaving: record.status === 2 || record.status === 3,
    tiposSepuluraToHide: [state.crudOrcamentoState.oidTipoSepulturaCapela],
    stateMarcador: state.crudMarcadorState,
    isUsarWebWhatsapp,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setField: (field, value) => dispatch(actions.setField(field, value)),
    saveHandler: (event) => {
      dispatch(actions.save())
    },
    removeHandler: (event) => {
      dispatch(actions.remove())
    },
    newHandler: (event) => {
      dispatch(actions.makeNew())
    },
    loadById: (oid) => dispatch(actions.loadById(oid)),
    contratar: () => dispatch(actions.contratar()),
    imprimir: (oid) => dispatch(actions.imprimir(oid)),
    abrirWebWhatsApp: ({ oidPessoa, telefone }) => dispatch(pessoaActions.abrirWebWhatsApp({ oidPessoa, telefone })),
    enviarWhatsApp: ({ oidPessoa, telefone, carregarMensageriaFn }) =>
      dispatch(pessoaActions.enviarWhatsApp({ oidPessoa, telefone, carregarMensageriaFn })),
    showWarningMessage: (message) => dispatch(actions.showWarningMessage(message)),
    cancelar: () => dispatch(actions.cancelar()),
  }
}

class OrcamentoFormPageContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showDialogRemove: false,
      activeIndex: 0,
      ALTERAR_VENDEDOR: storage.getAcao(acoes.ALTERAR_VENDEDOR),
      ALTERAR_AUXILIAR: storage.getAcao(acoes.ALTERAR_AUXILIAR),
      ACAO_CANCELAR_ORCAMENTO: storage.getAcao(acoes.ACAO_CANCELAR_ORCAMENTO),
      showConfirmarContratar: false,
      showConfirmarCancelar: false,
    }
    this.history = props.history

    actions.afterSave = ({ oid }) => {
      this.history.replace(`${routes.PATH_ORCAMENTO}/${oid}`)
    }
    actions.afterNew = () => {
      this.history.push(`${routes.PATH_ORCAMENTO}/novo`)
    }
    actions.afterRemove = () => {
      this.history.replace(`${routes.PATH_ORCAMENTO}`)
    }
    this.setField = props.setField
    this.contratar = props.contratar
    this.imprimir = props.imprimir
  }

  getDialogConfirmarCancelar() {
    if (this.state.showConfirmarCancelar) {
      return (
        <ConfirmDialog
          header={utils.getMessage(this.props.messagesDialog, 'dialog.titulo.confirmacao')}
          visible={this.state.showConfirmarCancelar}
          content={utils.getMessage(this.props.messages, 'orcamento.label.confirmaCancelamento')}
          confirm={this.props.cancelar}
          hideDialog={() => this.setState({ showConfirmarCancelar: false })}
        />
      )
    }
    return null
  }

  getDialogConfirmarContratacao() {
    if (this.state.showConfirmarContratar) {
      return (
        <ConfirmDialog
          header={utils.getMessage(this.props.messagesDialog, 'dialog.titulo.confirmacao')}
          visible={this.state.showConfirmarContratar}
          content={utils.getMessage(this.props.messages, 'orcamento.label.confirmaContratacao')}
          confirm={this.props.contratar}
          hideDialog={() => this.setState({ showConfirmarContratar: false })}
        />
      )
    }
    return null
  }

  componentDidMount() {
    const oidEntity = _.get(this, 'props.match.params.id', null)
    logarAcesso(oidEntity).then()
    if (oidEntity && parseInt(oidEntity)) {
      this.props.loadById(oidEntity)
    } else {
      this.props.newHandler()
    }
    const vendedor = _.get(this, 'props.record.vendedor.id', null)
    if (!vendedor && !_.isNumber(oidEntity)) {
      const nomePessoaUsuario = storage.getNomePessoaUsuario()
      const oidPessoaUsuario = storage.getOidPessoaUsuario()
      this.props.setField('vendedor', { id: oidPessoaUsuario, value: nomePessoaUsuario })
    }
  }

  searchHandler = () => {
    this.props.history.push(`${routes.PATH_ORCAMENTO}`)
  }

  hideDialog = () => {
    this.setState({ showDialogRemove: false })
  }

  buildHeader = () => {
    return <DefaultFormToolBar formPageContainer={this} />
  }

  onChangeUnit = (e) => {
    this.setField('unidade', e)
    // alterou unidade,reset no tipo
    this.setField('tipoSepultura', { id: '', value: '' })
  }

  setResponsavel = (data) => {
    const value = {
      id: _.get(data, 'oid', ''),
      value: { id: _.get(data, 'numeroDocumento', ''), value: _.get(data, 'nome', '') },
    }
    this.setField('responsavel', value)
    this.setField('telefoneResponsavel', _.get(data, 'telefone', ''))
  }

  getBotoesPersonalizados = () => {
    const oid = _.get(this, 'props.record.oid', null)
    const status = _.get(this, 'props.record.status', null)
    const disabled = !oid || status === 2 || status === 3 // 2 = confirmado, 3 = cancelado
    return [
      {
        type: 'button',
        label: 'Contratar',
        onClick: this.handlerContratar,
        icon: icons.CHECK_ICON,
        disabled,
        className: 'p-button-success',
      },
      {
        type: 'button',
        label: 'Imprimir',
        onClick: this.handlerImprimir,
        icon: icons.PRINT,
      },
      {
        type: 'button',
        label: utils.getMessage(this.props.messages, 'orcamento.label.cancelar'),
        onClick: this.handlerCancelar,
        icon: icons.TIMES_ICON,
        className: 'p-button-danger',
        disabled: !oid || !this.state.ACAO_CANCELAR_ORCAMENTO || status === 3, // 3 = cancelado
      },
    ]
  }

  handlerCancelar = () => {
    this.setState({ showConfirmarCancelar: true })
  }

  handlerContratar = () => {
    this.setState({ showConfirmarContratar: true })
    // const oid = _.get(this, 'props.record.oid', null)
    // if (oid) {
    //   this.contratar(oid)
    // }
  }

  handlerImprimir = () => {
    const oid = _.get(this, 'props.record.oid', null)
    if (oid) {
      this.imprimir(oid)
    }
  }

  onChangeTaxas = (data) => {
    this.setField('taxas', _.get(data, 'values', []))
    this.setValorTotal(data)
    this.setItemPrincipal(data)
  }

  setValorTotal = (data) => {
    let itens = _.get(data, 'values', [])
    let total = 0
    for (const value of itens) {
      const quantidade = _.get(value, 'quantidade', 0)
      const valorItem = _.get(value, 'valor', 0)
      total += utils.multiply(quantidade, valorItem, 2)
    }
    this.setField('valorTotal', total)
  }

  setItemPrincipal = (data) => {
    const values = _.get(data, 'values', [])
    if (utils.isArrayNullOrEmpty(values)) {
      this.setField('oidItemPrincipal', null)
      return
    }

    const oidItemPrincipalAtual = _.get(this, 'props.record.oidItemPrincipal', null)
    const serviceRemoved = _.get(data, 'serviceRemoved', null)
    const serviceAdded = _.get(data, 'serviceAdded', null)
    if (serviceAdded && !oidItemPrincipalAtual) {
      this.setField('oidItemPrincipal', _.get(serviceAdded, 'itemLancamento.oidTipo', null))
      this.setField('tipoItemPrincipal', _.get(serviceAdded, 'itemLancamento.tipo', null))
      return
    }

    if (serviceRemoved) {
      const oidTaxaRemoved = _.get(serviceRemoved, 'itemLancamento.oidTipo', null)
      if (oidTaxaRemoved === oidItemPrincipalAtual) {
        this.setField('oidItemPrincipal', _.get(values[0], 'itemLancamento.oidTipo', null))
        this.setField('tipoItemPrincipal', _.get(values[0], 'itemLancamento.tipo', null))
      }
    }
  }

  changeActiveIndex = (index) => {
    this.setState({ activeIndex: index })
  }

  carregarMensageria = (mensagem) => {
    this.props.history.push('/geral/cadastros/mensageria', { mensagem })
  }

  onClickWhatsAppButton = () => {
    const telefone = _.get(this, 'props.record.telefoneResponsavel', null)
    const oidPessoa = _.get(this, 'props.record.responsavel.id', null)
    if (!telefone || !oidPessoa) {
      this.props.showWarningMessage('É necessário ter um responsável que possua telefone para enviar WhatsApp.')
      return
    }
    if (this.props.isUsarWebWhatsapp) {
      this.props.abrirWebWhatsApp({ oidPessoa, telefone })
    } else {
      this.props.enviarWhatsApp({ oidPessoa, telefone, carregarMensageriaFn: this.carregarMensageria })
    }
  }

  render() {
    const content = (
      <React.Fragment>
        {this.getDialogConfirmarCancelar()}
        {this.getDialogConfirmarContratacao()}
        <OrcamentoForm
          state={this.state}
          changeActiveIndex={this.changeActiveIndex}
          record={this.props.record}
          onChangeUnit={this.onChangeUnit}
          setResponsavel={this.setResponsavel}
          history={this.props.history}
          statePessoaFisica={this.props.statePessoaFisica}
          setField={this.setField}
          currentUser={this.props.currentUser}
          canEditHistorico={this.props.canEditHistorico}
          canRemoveHistorico={this.props.canRemoveHistorico}
          onChangeTaxas={this.onChangeTaxas}
          tiposSepuluraToHide={this.props.tiposSepuluraToHide}
          stateMarcador={this.props.stateMarcador}
          messages={this.props.messages}
          alterarVendedor={this.state.ALTERAR_VENDEDOR}
          alterarAuxiliar={this.state.ALTERAR_AUXILIAR}
          onClickWhatsAppButton={this.onClickWhatsAppButton}
        />
      </React.Fragment>
    )

    return <Page header={this.buildHeader()} content={content} />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OrcamentoFormPageContainer)
